import { Award } from "lucide-react";

const credentials = [
  "International Master of Business Administration (IMBA), Birmingham City University – Distinction",
  "Experienced legal practitioner advising on property transactions and investor due diligence",
  "Founder of 4ACES Attorneys Property & Private Clients Practice",
  "Trusted legal counsel for diaspora investors acquiring property in Nigeria"
];

export const CredentialsSection = () => {
  return (
    <section 
      className="py-16 md:py-24 lg:py-32 bg-[#0A0A0B] relative overflow-hidden"
      data-testid="credentials-section"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      {/* Corner accents */}
      <div className="absolute top-12 left-12 w-20 h-20 border-l border-t border-[#D4AF37]/15 hidden lg:block" />
      <div className="absolute bottom-12 right-12 w-20 h-20 border-r border-b border-[#D4AF37]/15 hidden lg:block" />
      
      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="w-16 h-16 md:w-20 md:h-20 border border-[#D4AF37]/30 flex items-center justify-center mx-auto mb-6 md:mb-8">
            <Award className="w-8 h-8 md:w-10 md:h-10 text-[#D4AF37]" />
          </div>
          
          <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
            Leadership
          </span>
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-white mt-4 md:mt-6 leading-tight">
            Professional
            <span className="block text-[#D4AF37] italic">Credentials</span>
          </h2>
          <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mt-6 md:mt-8" />
        </div>

        {/* Introduction */}
        <p className="text-white/70 text-base md:text-lg lg:text-xl leading-relaxed text-center mb-10 md:mb-14 max-w-3xl mx-auto">
          <span className="text-white font-semibold">Precious Ohiri-Leghemo, Esq.</span> is the 
          Principal Partner of 4ACES Attorneys and advises private clients and investors on 
          legally structured property acquisitions in Nigeria.
        </p>

        {/* Credentials List */}
        <div className="space-y-4 md:space-y-5">
          {credentials.map((credential, index) => (
            <div 
              key={index}
              className="flex items-start gap-4 md:gap-5 p-5 md:p-6 border border-[#D4AF37]/20 bg-[#D4AF37]/5 hover:border-[#D4AF37]/40 transition-all duration-300"
              data-testid={`credential-${index}`}
            >
              <div className="w-2 h-2 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0" />
              <span className="text-white/80 text-sm md:text-base lg:text-lg leading-relaxed">
                {credential}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
